"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TitleWithExternalLink = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _buttonControl = _interopRequireDefault(require("@insided/deprecated-preact-components/button-control"));

var _Flag = _interopRequireDefault(require("../ui-components/Flag"));

var _BetaBadge = _interopRequireDefault(require("../ui-components/BetaBadge"));

var _OverviewSwitcher = _interopRequireDefault(require("../ui-components/OverviewSwitcher"));

var _common = require("@insided/shared/utils/common");

var _TitleInput = _interopRequireDefault(require("@insided/deprecated-preact-components/title-input/TitleInput"));

var _StatusCircle = _interopRequireDefault(require("../ui-components/StatusCircle"));

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StatusBadge = _interopRequireDefault(require("../ui-components/StatusBadge"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var reloadPage = function reloadPage() {
  window.location.reload();
};

function isComponent(item) {
  return (0, _typeof2.default)(item) === 'object' && item !== null && 'nodeName' in item;
}

var TitleWithExternalLink = function TitleWithExternalLink(props) {
  return (0, _preact.h)("span", {
    style: {
      display: 'flex'
    }
  }, props.title, (0, _preact.h)("a", {
    href: (0, _absoluteUrlRuntime.resolveUrl)(props.link),
    style: {
      paddingTop: '0.1em',
      marginLeft: '4px'
    },
    target: "_blank",
    rel: "noreferrer"
  }, (0, _preact.h)(_assets.default, {
    icon: "externalLink",
    height: 22,
    width: 22,
    color: "#9599A2"
  })));
};

exports.TitleWithExternalLink = TitleWithExternalLink;

var HeaderButton = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(HeaderButton, _Component);

  var _super = _createSuper(HeaderButton);

  function HeaderButton() {
    var _this;

    (0, _classCallCheck2.default)(this, HeaderButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "buttonRef", (0, _preact.createRef)());
    return _this;
  }

  (0, _createClass2.default)(HeaderButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      /**
       * Preact buttons don't support the form attribute when passed directly,
       * so we manually set it using the button reference
       */
      if (this.props.form) {
        var _this$buttonRef$curre;

        (_this$buttonRef$curre = this.buttonRef.current) === null || _this$buttonRef$curre === void 0 ? void 0 : _this$buttonRef$curre.setAttribute('form', this.props.form);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return (0, _preact.h)(_buttonControl.default, (0, _extends2.default)({}, this.props, {
        buttonRef: this.buttonRef
      }));
    }
  }]);
  return HeaderButton;
}(_preact.Component);

var Header = function Header(_ref) {
  var title = _ref.title,
      _ref$saveCallback = _ref.saveCallback,
      saveCallback = _ref$saveCallback === void 0 ? function () {} : _ref$saveCallback,
      _ref$cancelCallback = _ref.cancelCallback,
      cancelCallback = _ref$cancelCallback === void 0 ? reloadPage : _ref$cancelCallback,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      _ref$hasBreadcrumb = _ref.hasBreadcrumb,
      hasBreadcrumb = _ref$hasBreadcrumb === void 0 ? false : _ref$hasBreadcrumb,
      breadcrumbLink = _ref.breadcrumbLink,
      breadcrumbText = _ref.breadcrumbText,
      _ref$disableCancelBut = _ref.disableCancelButton,
      disableCancelButton = _ref$disableCancelBut === void 0 ? false : _ref$disableCancelBut,
      _ref$disableSaveButto = _ref.disableSaveButton,
      disableSaveButton = _ref$disableSaveButto === void 0 ? false : _ref$disableSaveButto,
      _ref$customButtons = _ref.customButtons,
      customButtons = _ref$customButtons === void 0 ? [] : _ref$customButtons,
      _ref$statusLabelText = _ref.statusLabelText,
      statusLabelText = _ref$statusLabelText === void 0 ? undefined : _ref$statusLabelText,
      _ref$statusLabelSucce = _ref.statusLabelSuccess,
      statusLabelSuccess = _ref$statusLabelSucce === void 0 ? false : _ref$statusLabelSucce,
      _ref$statusLabelSecon = _ref.statusLabelSecondary,
      statusLabelSecondary = _ref$statusLabelSecon === void 0 ? false : _ref$statusLabelSecon,
      _ref$customComponent = _ref.customComponent,
      customComponent = _ref$customComponent === void 0 ? undefined : _ref$customComponent,
      _ref$isBeta = _ref.isBeta,
      isBeta = _ref$isBeta === void 0 ? false : _ref$isBeta,
      onTitleChanged = _ref.onTitleChanged,
      placeholder = _ref.placeholder,
      statusVariant = _ref.statusVariant,
      status = _ref.status,
      statusBadge = _ref.statusBadge,
      endIcon = _ref.endIcon,
      iconOnClick = _ref.iconOnClick,
      headerTabs = _ref.headerTabs;
  var headerClass = (0, _classnames.default)('control-header', hasBreadcrumb && 'control-header--breadcrumb', onTitleChanged && 'control-header--title-input');
  return (0, _preact.h)("div", {
    className: headerClass
  }, (0, _preact.h)("div", {
    className: "control-header__texts-container"
  }, hasBreadcrumb && (0, _preact.h)("span", {
    className: "control-header__breadcrumb"
  }, (0, _preact.h)("a", {
    className: "control-header__breadcrumb-link",
    href: (0, _absoluteUrlRuntime.resolveUrl)(breadcrumbLink)
  }, breadcrumbText)), status && !statusBadge && (0, _preact.h)("div", {
    className: "control-header__status"
  }, (0, _preact.h)(_StatusCircle.default, {
    variant: statusVariant
  }), status), onTitleChanged && typeof title === 'string' ? (0, _preact.h)(_TitleInput.default, {
    title: title,
    onTitleChanged: onTitleChanged,
    placeholder: placeholder
  }) : (0, _preact.h)("div", {
    className: "control-header__title"
  }, (0, _preact.h)("h2", null, title), endIcon && (0, _preact.h)(_assets.default, {
    icon: endIcon,
    onClick: iconOnClick,
    customClass: "external-link-icon"
  }), _common.common.isModuleActive('moderationOverviewBetaDefault') && window.location.pathname === '/moderation/overview' && window.location.search === '' && (0, _preact.h)(_OverviewSwitcher.default, null), statusLabelText && (0, _preact.h)(_Flag.default, {
    text: statusLabelText,
    success: statusLabelSuccess,
    secondary: statusLabelSecondary
  }), statusBadge && (0, _preact.h)(_StatusBadge.default, {
    variant: status
  }, status !== null && status !== void 0 ? status : ''), isBeta && (0, _preact.h)(_BetaBadge.default, null))), headerTabs && (0, _preact.h)("div", {
    className: (0, _classnames.default)('control-header__tabs', 'sections__nav', {
      'pu-extra-margin': title !== 'Ideation',
      'idea-extra-marge': title === 'Ideation'
    })
  }), (0, _preact.h)("div", {
    className: "control-header__buttons"
  }, !disableCancelButton && (0, _preact.h)(_buttonControl.default, {
    title: "Cancel",
    onClick: function onClick() {
      return cancelCallback();
    },
    newStyle: true,
    className: "js-cancel",
    size: "medium"
  }), !disableSaveButton && (0, _preact.h)(_buttonControl.default, {
    variant: "success",
    title: "Save Changes",
    onClick: function onClick() {
      return saveCallback();
    },
    disabled: isLoading,
    isLoading: isLoading,
    newStyle: true,
    className: "js-submit",
    size: "medium"
  }), customButtons ? customButtons.map(function (item, idx) {
    if (!item) return null;
    if (isComponent(item)) return item;
    var url = item.url,
        customClass = item.customClass,
        variant = item.variant,
        title = item.title,
        action = item.action,
        newStyle = item.newStyle,
        size = item.size,
        form = item.form,
        type = item.type;
    if (!action && !url) return null;
    return (0, _preact.h)("a", {
      className: "control-header__button-wrapper",
      href: (0, _absoluteUrlRuntime.resolveUrl)(url),
      key: idx
    }, (0, _preact.h)(HeaderButton, {
      newStyle: newStyle,
      variant: variant,
      className: customClass,
      title: title,
      onClick: type === 'submit' ? undefined : action,
      size: size,
      form: form,
      type: type !== null && type !== void 0 ? type : 'button'
    }));
  }) : null), customComponent && customComponent);
};

var _default = Header;
exports.default = _default;